import dayjs from 'dayjs'

export const getDateIso = () => dayjs().format()

export const getDay = () => dayjs().format('dddd')
